var TabNames;
(function (TabNames) {
    TabNames[TabNames["Description"] = 0] = "Description";
    TabNames[TabNames["Details"] = 1] = "Details";
    TabNames[TabNames["ProductTab3"] = 2] = "ProductTab3";
    TabNames[TabNames["ProductTab4"] = 3] = "ProductTab4";
    TabNames[TabNames["ShippingReturns"] = 4] = "ShippingReturns";
    TabNames[TabNames["AccorRewards"] = 5] = "AccorRewards";
})(TabNames || (TabNames = {}));
({
    [TabNames.Description]: 'description',
    [TabNames.Details]: 'details',
    [TabNames.ProductTab3]: '3',
    [TabNames.ProductTab4]: '4',
    [TabNames.ShippingReturns]: 'shipping-returns',
    [TabNames.AccorRewards]: 'rewards',
});

export { TabNames as T };
//# sourceMappingURL=types-iWC93EMW.js.map
